import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// This is safe to have in code as these are just identifiers and have nothing to do with auth.
const firebaseConfig = {
  apiKey: "AIzaSyDojLpBDfJH5kp23DYpNp3qwK9gxHR9JTE",
  authDomain: "tsundraki-studio.firebaseapp.com",
  databaseURL: "https://tsundraki-studio-default-rtdb.firebaseio.com",
  projectId: "tsundraki-studio",
  storageBucket: "tsundraki-studio.firebasestorage.app",
  messagingSenderId: "695614803035",
  appId: "1:695614803035:web:a220af57ef96db08fa837e",
  measurementId: "G-EXX47M91ZF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
